/* global THREE */

export default class HopeTotemLabel extends THREE.Mesh {
  constructor (labelText = '') {
    let width = 3 // 2
    let height = 0.75 // 0.5
    let geom = new THREE.PlaneBufferGeometry(width, height, 1, 1)
    geom.translate(0, height / 2, 0)

    let canvas = document.createElement('canvas')
    canvas.width = 1024
    canvas.height = 256
    let material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      map: new THREE.Texture(canvas)
    })
    material.onBeforeCompile = function (mat) {
      mat.fragmentShader = mat.fragmentShader.replace('#include <fog_fragment>', '#ifdef USE_FOG\nfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n gl_FragColor.a *= 1.0 - fogFactor;\n#endif')
    }
    super(geom, material)

    this.canvas = canvas
    // this.draw(labelText)
    this._labelText = labelText
  }

  disable () {
    let ctx = this.canvas.getContext('2d')
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    ctx.font = '600 76px Muli'
    ctx.fillStyle = 'rgb(97, 97, 97)'
    ctx.textAlign = 'center'
    ctx.fillText(this._labelText.toUpperCase(), this.canvas.width / 2, this.canvas.height / 2)

    this.material.map.needsUpdate = true
  }

  enable () {
    let ctx = this.canvas.getContext('2d')
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    ctx.font = '600 76px Muli'
    ctx.fillStyle = 'rgb(97, 97, 97)'
    ctx.textAlign = 'center'
    ctx.fillText(this._labelText.toUpperCase(), this.canvas.width / 2, this.canvas.height / 2)

    ctx.font = '400 65px Muli'
    ctx.fillStyle = '#b4b4b4'

    ctx.fillText(this._labelTextSubtitle, this.canvas.width / 2, this.canvas.height / 1.2)

    this.material.map.needsUpdate = true
  }

  draw (labelText, subtitle = 'Your hopes, by topic') {
    let ctx = this.canvas.getContext('2d')

    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    this._labelTextSubtitle = subtitle

    // ctx.fillStyle = '#ff0000'
    // ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)

    ctx.font = '600 76px Muli'
    ctx.fillStyle = 'rgb(97, 97, 97)'
    ctx.textAlign = 'center'
    ctx.fillText(labelText.toUpperCase(), this.canvas.width / 2, this.canvas.height / 2)

    ctx.font = '400 65px Muli'
    ctx.fillStyle = '#b4b4b4'
    ctx.fillText(subtitle, this.canvas.width / 2, this.canvas.height / 1.2)

    // let triangleSize = 50
    // ctx.moveTo(this.canvas.width / 2, this.canvas.height)
    // ctx.lineTo((this.canvas.width / 2) - triangleSize, this.canvas.height - triangleSize)
    // ctx.lineTo((this.canvas.width / 2) + triangleSize, this.canvas.height - triangleSize)
    // ctx.fill()

    this.material.map.needsUpdate = true
  }
}



// WEBPACK FOOTER //
// ./src/atoms/HopeTotemLabel.js